define('controllers/refund',['require','nicEditlatest','utils','layout','services/userService'],function (require) {
  "use strict";
  require("nicEditlatest");
  var utils = require("utils");
  var layout = require("layout");
  var userService = require("services/userService");
  return {
    load: function (hashQuerystring, data, state) {
      function init() {
        var refundForm = $("#refundForm"),
          buttons = $("button", refundForm),
          submitButton = $("#send", refundForm),
          requestFullRefundCheckbox = $("#requestFullRefund", refundForm),
          accountClosingConfirmButton = $("#accountClosingConfirm", refundForm),
          message = $("#message"),
          amountBox = $('[name="Amount"]', refundForm),
          bodyId = "refundBody",
          bodyEditor = new window.nicEditor({
            fullPanel: true,
            maxHeight: 400,
          }).panelInstance(bodyId, { hasPanel: true }),
          success = $("#success");
        var accountClosing = false;
        var user = window.ServerData.user;
        var numberAmount = 0;
        var memberSupportEmail = window.ServerData.Emails.MemberSupport;

          if (userService.inRole("CallCenter,HelpDesk,Admin")) {
          document.getElementById("adminOnly").hidden = false;
        }

        //make sure user isnt requesting a refund in past the hundreths of a dollar
        //if input has more than the hundreths place, return false
        function hasAtMostTwoDecimals(value) {
          return /^\d+(\.\d{1,2})?$/.test(value);
        }

        function validateRefundAmount(data) {
          var cleanedAmount = data.replace(/[, $]+/g, "");
          var errorString = "";
          numberAmount = Number(cleanedAmount);
          if (isNaN(numberAmount)) {
            errorString =
              "Please enter a valid number for your requested refund amount.";
          } else if (numberAmount < 0.0) {
            errorString = "Please enter a refund amount above 0.00";
          } else if (!hasAtMostTwoDecimals(numberAmount)) {
            errorString =
              "Please enter a valid number for your requested refund amount with no more than two decimal places.";
          }
          return errorString;
        }

        function validate(data) {
          var errors = [];
          for (var field in data) {
            if (data.hasOwnProperty(field)) {
              if (
                typeof data[field] === "string" &&
                data[field].trim() === "" &&
                field !== "Comment"
              ) {
                errors.push("Please enter a value for {0}.".format(field));
              } else if (field === "Amount") {
                var valid = validateRefundAmount(data[field]);
                if (valid !== "") {
                  errors.push(valid);
                }
              }
            }
          }
          errors.length > 0
            ? window.Utilities.setError(errors.join("<br/>"), message)
            : message.hide(); // jshint ignore:line
          return errors.length === 0;
        }

        //Check if member is logged in.  If they aren't, they will be sent to the login page
        $.post("/api/refund/IsLoggedIn");

        //clear body box
        bodyEditor.instanceById(bodyId).setContent("");

        //remove the html tags from the niceditor comment box
        function convertToPlainText(html) {
          var tempDivElement = document.createElement("div");
          tempDivElement.innerHTML = html;
          return tempDivElement.textContent || tempDivElement.innerText || "";
        }

        function sendRefundRequest() {
          var assignUserId = user.member.UserID;
          //set assignUserId to the user who is doing the DBA'ing
          if (user.isDba) {
            assignUserId = user.id;
          }
          var data = {
            Amount: amountBox.val(),
            AccountClosing: accountClosing,
            //use member's userId
            UserId: user.member.UserID,
            AssignUserId: assignUserId,
            Comment: convertToPlainText(
              bodyEditor.instanceById(bodyId).getContent()
            ),
          };
          if (validate(data)) {
            data.Amount = numberAmount;
            buttons.prop("disabled", true);

            $.post("/api/refund/send", data)
              .then(function (response) {
                if (response && response.success === true) {
                  window.Utilities.setInfo(
                    "Your request is being processed!",
                    message
                  );

                  submitButton.show();
                  refundForm.hide();
                  success.show();
                } else {
                  window.Utilities.setError(
                    response.message || "Unable to process refund request.",
                    message
                  );
                }

                buttons.prop("disabled", false);
              })
              .fail(function (err) {
                var errorMessage =
                  utils.tryGetValue(err, "responseJSON.Message") ||
                  err.message ||
                  "An error occurred while sending the refund request. Please try again later..";

                window.Utilities.setError(
                  errorMessage ||
                    "An error occurred while sending the refund request. Please try again later.",
                  message
                );

                buttons.prop("disabled", false);
              });
          }
        }

        submitButton.on("click", function (e) {
          sendRefundRequest();
        });

        accountClosingConfirmButton.on("click", function () {
          //set closed flag to true
          amountBox.val("0.00").trigger("change");
          accountClosing = true;
          sendRefundRequest();
          $.fancybox.close();
        });

        // set Amount = 0.00 to indicate full refund to SPROC
        requestFullRefundCheckbox.on("change", function () {
          if ($(this).is(":checked")) {
            // checked, set full refund and disable amount change
            amountBox.val("0.00").trigger("change");
            amountBox.prop("disabled", true);
          } else {
            // unchecked
            amountBox.val("").trigger("change");
            amountBox.prop("disabled", false);
          }
        });

        window.Utilities.setDefaultButton(refundForm, submitButton);
        amountBox.focus();

        layout.initGlobalHandlers(); //placeholder

        //set member support email using config
        $("[data-memberSupportEmail]").each(function () {
          $(this)
            .attr("href", `mailto:${memberSupportEmail}`)
            .text(memberSupportEmail);
        });

        //display user name when closing account
        $("#userFullName").text(
          user.member.NameFirst + " " + user.member.NameLast
        );
      }

      return layout.initStatic("/fe/templates/about/refund").then(init);
    },
    unload: function () {
      var refundForm = $("#refundForm");
      window.Utilities.unSetDefaultButton(refundForm);
      $("#send", refundForm).off("click");
    },
  };
});

